























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Route } from '@/router/route.model';
import LeftBarNotificationArrow from '@/componentsV2/molecules/LeftBarNotificationArrow/LeftBarNotificationArrow.vue';

@Component({ components: { LeftBarNotificationArrow } })
export default class BusinessMenuItem extends Vue {
  @Prop(Boolean) readonly viewOnly: boolean | undefined;
  @Prop(String) readonly path!: string;
  @Prop(String) readonly title!: string;
  @Prop(Function) readonly click!: any;
  @Prop(Route) readonly route!: Route;
  @Prop() notification?: any;

  active: boolean = false;

  menuNotificationOffset = {
    top: 0,
    left: 0
  };

  onClick(event: any) {
    if (this.viewOnly) {
      event.preventDefault();
      return false;
    }

    if (this.click) {
      return this.click(event);
    }

    event.preventDefault();

    if (this.path) {
      this.$router.push(this.path);
    }
  }

  get screenSmall() {
    return window.innerWidth <= 1280;
  }

  get showLeftBarNotification() {
    if (!this.route) return false;

    return (
      !this.$mobileCheck() &&
      this.notification &&
      this.route.path === this.notification.link &&
      !this.screenSmall
    );
  }

  @Watch('notification')
  setMenuNotificationOffset() {
    if (
      !this.notification ||
      !this.route ||
      this.notification.link !== this.route.path
    )
      return;

    setTimeout(() => {
      this.menuNotificationOffset = this.getMenuItemOffset(
        '.notification-arrow'
      );
    });
  }

  @Watch('$route')
  onRouteChange() {
    this.active = this.$route.path === this.path;
  }

  getMenuItemOffset(selector: string) {
    let { left, top, width, height } = this.$el.getBoundingClientRect();
    const el = this.$el.querySelector(selector) as HTMLElement;

    if (el) {
      const tooltipOffset = el.getBoundingClientRect();

      return {
        left: left + width,
        top: top + height / 2 - tooltipOffset.height / 2
      };
    }
    return { left: 0, top: 0 };
  }

  mounted() {
    this.active = this.$route.path === this.path;
  }
}
